import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EthosWriterForm from '../forms/ethos-writer-form';
import { ethosWriterValidationSchema } from '../schema/ethosWriter.js';

export default function EthosWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Ethos Writer Node Details',
        altText: 'Ethos Writer Node',
        defaultLabel: 'Ethos Writer Node',
      }}
    >
      <CommonNode FormComponent={EthosWriterForm} schemaResolver={ethosWriterValidationSchema} />
    </NodeProvider>
  );
}
